import {
	Checkbox,
	InputAdornment,
	TextField,
	TextFieldProps,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ChangeEvent, FocusEvent } from "react";

const useStyles = makeStyles((theme) => ({
	container: {
		display: "flex",
		flexWrap: "nowrap",
		width: "100%",
	},
	field: {
		flex: 1,
		minWidth: 0,
	},
	leftField: {
		"& .MuiOutlinedInput-root": {
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
			borderRight: "none",
		},
	},
	rightField: {
		"& .MuiOutlinedInput-root": {
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
		},
	},
}));

interface SplitFieldCheckboxProps {
	leftLabel: string;
	leftValue: string | number | null;
	leftDisabled?: boolean;
	onLeftChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	onLeftBlur?: (event: FocusEvent<HTMLInputElement>) => void;
	rightLabel: string;
	rightValue?: string | number | null;
	rightDisabled?: boolean;
	onRightChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	onRightBlur?: (event: FocusEvent<HTMLInputElement>) => void;
	checkboxChecked?: boolean;
	onCheckboxChange?: (checked: boolean) => void;
	onCheckboxBlur?: (event: FocusEvent<HTMLButtonElement>) => void;
	disabled?: boolean;
	size?: TextFieldProps["size"];
	variant?: TextFieldProps["variant"];
}

export const SplitFieldCheckbox = ({
	leftLabel,
	leftValue,
	leftDisabled = false,
	onLeftChange,
	onLeftBlur,
	rightLabel,
	rightValue,
	rightDisabled = false,
	onRightChange,
	onRightBlur,
	checkboxChecked = false,
	onCheckboxChange,
	onCheckboxBlur,
	disabled = false,
	size = "small",
	variant = "outlined",
}: SplitFieldCheckboxProps) => {
	const classes = useStyles();

	const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
		onCheckboxChange?.(e.target.checked);
	};

	const shrinkRightLabel =
		rightValue !== null && rightValue !== undefined && rightValue !== "";

	return (
		<div className={classes.container}>
			<TextField
				className={`${classes.field} ${classes.leftField}`}
				label={leftLabel}
				variant={variant}
				disabled={leftDisabled}
				size={size}
				value={leftValue ?? ""}
				onChange={onLeftChange}
				onBlur={onLeftBlur}
				InputLabelProps={{ shrink: true }}
				InputProps={{
					style: {
						borderTopRightRadius: "0",
						borderBottomRightRadius: "0",
					},
				}}
			/>
			<TextField
				className={`${classes.field} ${classes.rightField}`}
				label={rightLabel}
				variant={variant}
				disabled={rightDisabled}
				size={size}
				value={rightValue ?? ""}
				onChange={onRightChange}
				onBlur={onRightBlur}
				InputLabelProps={{ shrink: shrinkRightLabel }}
				InputProps={{
					style: {
						borderTopLeftRadius: "0",
						borderBottomLeftRadius: "0",
					},
					endAdornment: onCheckboxChange ? (
						<InputAdornment position="end">
							<Checkbox
								color="primary"
								size="small"
								checked={checkboxChecked}
								disabled={disabled}
								onChange={handleCheckboxChange}
								onBlur={onCheckboxBlur}
							/>
						</InputAdornment>
					) : undefined,
				}}
			/>
		</div>
	);
};
